module.exports = __webpack_public_path__ + "static/media/ill_hosta.1765bc89.svg";